export default "__VITE_ASSET__c28d711c__"